var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartaoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    viewBox: "0 0 356 229",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M350 23v177c0 12-4 18-14 18H28c-10 0-15-6-16-18V24c0-12 5-18 16-18l308 1c9 1 15 5 14 16z",
    fill: "#e4e4e4",
    stroke: "#a9a6aa",
    strokeWidth: 8.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M151 69l-14 84h22l14-84h-22zm-32 0l-21 58-2-12-1-3c-2-6-8-16-19-25-3-2-7-5-10-6l19 72h23l34-84h-23zm85 24c0-10 21-9 31-3l3-18s-10-4-20-4c-11 0-36 5-36 28 0 21 30 22 30 33s-27 9-36 2l-3 19s9 5 24 5 38-8 38-29c0-22-31-24-31-33zm89-24h-17c-9 0-11 7-11 7l-32 77h23l4-12h28l3 12h20l-18-84zm-26 54l11-31 6 31h-17z",
    fill: "#005bac"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M89 77s-1-7-11-7H43v1s17 4 33 16c15 13 20 28 20 28l-7-38z",
    fill: "#f6ac1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartaoVisa);
export default __webpack_public_path__ + "static/media/cartao-visa.8b3494c6b990aaca40a84c1e39d39494.svg";
export { ForwardRef as ReactComponent };